import React from "react";
import { createPortal } from "react-dom";
import { X, ArrowSquareOut } from "@phosphor-icons/react";

// In-app viewer for external evac/perimeter maps (perimetermap.com allows
// embedding via frame-ancestors *). Escape hatch link opens a new tab.
export default function PerimeterMapModal({ url, title = "Perimeter Map", onClose }) {
  if (!url) return null;
  return createPortal(
    <div
      data-testid="perimeter-map-modal"
      className="fixed inset-0 z-[1400] bg-black/80 backdrop-blur-sm flex items-center justify-center p-3 sm:p-6"
      onClick={onClose}
    >
      <div
        className="w-full max-w-6xl h-[88vh] bg-tac-bg border border-tac-border rounded-sm shadow-2xl flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-2 px-4 py-2.5 border-b border-tac-border shrink-0">
          <span className="text-[12px] font-bold uppercase tracking-[0.15em] text-tac-text truncate">{title}</span>
          <div className="flex items-center gap-3 shrink-0">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="perimeter-map-external"
              className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-tac-dim hover:text-tac-primary"
            >
              Open in new tab <ArrowSquareOut size={11} weight="bold" />
            </a>
            <button
              type="button"
              data-testid="perimeter-map-close"
              onClick={onClose}
              className="text-tac-dim hover:text-tac-text"
            >
              <X size={18} weight="bold" />
            </button>
          </div>
        </div>
        <iframe
          src={url}
          title={title}
          data-testid="perimeter-map-iframe"
          className="flex-1 w-full border-0 bg-white"
          allow="geolocation"
        />
      </div>
    </div>,
    document.body
  );
}
